import svg4everybody from "svg4everybody";
import App from "./app";
import './header';
import './read-more';

document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.remove('no-js');
  if (App.userAgent.isIE) {
    svg4everybody();
  }
});
